import React, { Children, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const MuiModal = ({
  openModal,
  setOpenModal,
  children,
  width,
  isOverflow,
  isNotBackdropClick,
  disableEscapeKeyDown=false,
}) => {
  let windowWidth = window.screen.width;

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpenModal(false);
    }
  };

  return (
    <>
      <MuiTheme>
        <Modal
          sx={{ overflow: "scroll" }}
          disableEscapeKeyDown={disableEscapeKeyDown}
          open={openModal}
          onClose={isNotBackdropClick ? handleClose : () => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className={isOverflow ? "flex justify-center" : ""}>
            <Box
              className={
                windowWidth > 768
                  ? isOverflow
                    ? `panel-modal-box-overflow ${width}`
                    : `panel-modal-box ${width}`
                  : isOverflow
                  ? `panel-modal-box-overflow w-11/12`
                  : `panel-modal-box w-11/12 `
              }
            >
              {children}
            </Box>
          </div>
        </Modal>
      </MuiTheme>
    </>
  );
};

export default MuiModal;
